<template>
  <div v-if="marketplaces">
    <img
      v-if="searchMarketplace('QAS')"
      :src="qasMarketplaceIcon"
      height="40"
      width="55"
      style="max-width: 100px"
    />
    <img
      v-if="searchMarketplace('CANAM')"
      :src="canamMarketplaceIcon"
      height="40"
      width="55"
      style="max-width: 100px"
    />
  </div>
</template>

<script>
import Config from "@/config";

export default {
  props: ["marketplaces"],
  computed: {
    qasMarketplaceIcon() {
      return `${Config.baseURL()}/storage/system/QAS_marketplace.svg`;
    },
    canamMarketplaceIcon() {
      return `${Config.baseURL()}/storage/system/CANAM_marketplace.svg`;
    },
  },
  methods: {
    searchMarketplace(marketplace) {
      return this.marketplaces.find(
        (marketplaceItem) => marketplaceItem.name === marketplace
      );
    },
  },
};
</script>

<style>
</style>